<template>
	<div class="preview-spinner"></div>
</template>

<style>
@keyframes preview-spinner {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}

.preview-spinner:before {
	content: '';
	position: absolute;
	top: 50%;
	left: 50%;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	border: 2px solid #fff;
	border-top-color: #31dedc;
	margin-top: -13px;
	margin-left: -13px;
	-webkit-animation: preview-spinner 0.6s linear infinite;
	-moz-animation: preview-spinner 0.6s linear infinite;
	animation: preview-spinner 0.6s linear infinite;
}

.preview-spinner {
	position: relative;
	width: 30px;
	height: 30px;
}
</style>
